import React from 'react'

export const ConsumptionRecord = React.lazy(
  () => import('./MaterialUsageReport')
)
export const ConsumptionManagement = React.lazy(
  () => import('./MaterialManagement')
)
